export default {
  required: value => !!value || 'Обязательное поле',
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'Неверный e-mail'
  },
  inn: value => {
    const pattern = /(^[0-9]{10}$)|(^[0-9]{12}$)/;
    return pattern.test(value) || 'Неверный ИНН';
  },
}


// WEBPACK FOOTER //
// ./webapp/rules.js